export default {
  notEmpty: value => value ? undefined : 'O campo deve ser preenchido',
  cpfLength: value =>  value && value.length === 14 ? undefined : 'CPF inválido',
  telLength: value =>  value && value.length >= 14 ? undefined : 'Telefone inválido',
  cepLength: value =>  value && value.length === 9 ? undefined : 'CEP inválido',
  email: value =>  /^\S+@\S+\.\S+/g.test(value) ? undefined : 'E-mail inválido',
  wihSpace: value => /\s/.test(value) ? undefined : 'Preencha o nome completo',
}
